export default "__VITE_ASSET__Do4mekAt__"